import React from "react";
import AppUserLeftPanel from "../LeftPanel/AppUserLeftPanel";
import AppUserMiddlePanel from "../MiddlePanel/AppUserMiddlePanel";
import AppUserRightPanel from "../RightPanel/AppUserRightPanel";

const AppUserListBody = () => {
  return (
    <section className="feed_pnltotal">
      <div className="container-fluid">
        <div className="pnl_outer">
          <AppUserLeftPanel />
          <AppUserMiddlePanel />
          <AppUserRightPanel />
        </div>
      </div>
    </section>
  );
};

export default AppUserListBody;
